"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HoverManager_eventEngine, _HoverManager_logger, _HoverManager_tree, _HoverManager_currentlyDragging, _HoverManager_dragEventTokenEnd, _HoverManager_dragEventTokenStart, _HoverManager_filter, _HoverManager_groupInteractionEffectToken, _HoverManager_groupedNodes, _HoverManager_interactionEffectTokens, _HoverManager_intersections, _HoverManager_nodes;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverManager = void 0;
const viewer_1 = require("@shapediver/viewer");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const IInteractionEngine_1 = require("../../interfaces/IInteractionEngine");
const AbstractInteractionManager_1 = require("../AbstractInteractionManager");
const InteractionManagerUtils_1 = require("../utils/InteractionManagerUtils");
/* eslint-disable @typescript-eslint/no-unused-vars */
class HoverManager extends AbstractInteractionManager_1.AbstractInteractionManager {
    constructor(id, interactionEffect) {
        super(id, interactionEffect);
        _HoverManager_eventEngine.set(this, viewer_shared_services_1.EventEngine.instance);
        _HoverManager_logger.set(this, viewer_shared_services_1.Logger.instance);
        _HoverManager_tree.set(this, viewer_shared_node_tree_1.Tree.instance);
        _HoverManager_currentlyDragging.set(this, false);
        _HoverManager_dragEventTokenEnd.set(this, void 0);
        _HoverManager_dragEventTokenStart.set(this, void 0);
        _HoverManager_filter.set(this, InteractionManagerUtils_1.InteractionManagerUtils.createInteractionFilter("hover", this.id, [
            IInteractionEngine_1.INTERACTION_STATE.MOVE,
            IInteractionEngine_1.INTERACTION_STATE.END,
        ]));
        _HoverManager_groupInteractionEffectToken.set(this, []);
        _HoverManager_groupedNodes.set(this, []);
        _HoverManager_interactionEffectTokens.set(this, []);
        _HoverManager_intersections.set(this, []);
        _HoverManager_nodes.set(this, []);
        __classPrivateFieldSet(this, _HoverManager_dragEventTokenStart, (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE.INTERACTION.DRAG_START, () => {
            __classPrivateFieldSet(this, _HoverManager_currentlyDragging, true, "f");
        }), "f");
        __classPrivateFieldSet(this, _HoverManager_dragEventTokenEnd, (0, viewer_1.addListener)(viewer_shared_services_1.EVENTTYPE.INTERACTION.DRAG_END, () => {
            __classPrivateFieldSet(this, _HoverManager_currentlyDragging, false, "f");
        }), "f");
    }
    get filter() {
        return __classPrivateFieldGet(this, _HoverManager_filter, "f");
    }
    add(viewport) {
        this.viewport = viewport;
    }
    /**
     * Deselect the current node.
     */
    deselect(node) {
        if (__classPrivateFieldGet(this, _HoverManager_nodes, "f").includes(node))
            this.deactivateNode(node);
    }
    /**
     * Deselect all nodes.
     */
    deselectAll() {
        while (__classPrivateFieldGet(this, _HoverManager_nodes, "f").length > 0)
            this.deactivateNode(__classPrivateFieldGet(this, _HoverManager_nodes, "f")[0]);
    }
    onDown(event, ray, intersection) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _HoverManager_logger, "f")))
            return;
    }
    onEnd(event, ray, intersection, endState) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _HoverManager_logger, "f")))
            return;
        // Check if box selection was involved in this interaction
        const hasBoxSelection = intersection.some((i) => i.type === "BoxSelectionIntersection");
        // If box selection was active, clear all hover effects immediately
        // since they should not persist after box selection ends
        if (hasBoxSelection && __classPrivateFieldGet(this, _HoverManager_nodes, "f").length > 0) {
            this.deactivateAllNodes();
        }
    }
    onKeyDown(event, pointerInCanvas) { }
    onKeyUp(event, pointerInCanvas) { }
    onMove(event, ray, intersection) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _HoverManager_logger, "f")))
            return;
        // if a node is currently being dragged, do not hover any other nodes
        if (__classPrivateFieldGet(this, _HoverManager_currentlyDragging, "f")) {
            if (__classPrivateFieldGet(this, _HoverManager_nodes, "f").length > 0)
                this.deactivateAllNodes();
            return;
        }
        const intersections = intersection.filter((i) => this.filter(IInteractionEngine_1.INTERACTION_STATE.MOVE)(i.node));
        // create a list that replaces all irrelevant intersections with null
        const filteredIntersections = intersections.map((i) => {
            const data = InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(i.node, true, this.id, "hover");
            return data && !data.interactionStates.drag ? i : null;
        });
        // check if there are objects that were selected via box selection
        const hasBoxSelection = filteredIntersections.some((fi) => (fi === null || fi === void 0 ? void 0 : fi.type) === "BoxSelectionIntersection");
        // if there are no box selection intersections, adjust the filteredIntersections to only contain the first ray tracing intersection
        if (!hasBoxSelection) {
            const firstIntersectionIndex = filteredIntersections.findIndex((fi) => (fi === null || fi === void 0 ? void 0 : fi.type) === "RayTracingIntersection");
            for (let i = 0; i < filteredIntersections.length; i++) {
                if (i !== firstIntersectionIndex) {
                    filteredIntersections[i] = null;
                }
            }
        }
        // loop through all the new nodes
        // then activate those that are not yet active
        for (const fi of filteredIntersections) {
            if (fi) {
                if (!__classPrivateFieldGet(this, _HoverManager_nodes, "f").includes(fi.node)) {
                    this.activateNode(fi, event, ray);
                }
            }
        }
        // deactivate those that are no longer hovered
        for (const n of __classPrivateFieldGet(this, _HoverManager_nodes, "f")) {
            if (!filteredIntersections.find((fi) => fi && fi.node === n)) {
                this.deactivateNode(n, event);
            }
        }
    }
    remove() {
        this.deactivateAllNodes();
        this.viewport = undefined;
        (0, viewer_1.removeListener)(__classPrivateFieldGet(this, _HoverManager_dragEventTokenStart, "f"));
        (0, viewer_1.removeListener)(__classPrivateFieldGet(this, _HoverManager_dragEventTokenEnd, "f"));
    }
    /**
     * Select a node for hovering.
     * The point and distance of the intersection can be freely chosen and are provided in the event callbacks.
     *
     * @param intersection
     */
    select(intersection) {
        var _a;
        if (__classPrivateFieldGet(this, _HoverManager_nodes, "f").includes(intersection.node))
            this.deactivateNode(intersection.node);
        this.activateNode(Object.assign(Object.assign({}, intersection), { type: (_a = intersection.type) !== null && _a !== void 0 ? _a : "RayTracingIntersection" }));
    }
    /**
     * Utility function to make the node the current active node.
     * Set the according values, apply the effect and emit the event.
     *
     * @param intersection
     * @param event
     * @param ray
     */
    activateNode(intersection, event, ray) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _HoverManager_logger, "f")))
            return;
        __classPrivateFieldGet(this, _HoverManager_intersections, "f").push(intersection);
        __classPrivateFieldGet(this, _HoverManager_nodes, "f").push(intersection.node);
        // find the interaction data
        const data = InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(intersection.node, true, this.id, "hover");
        if (data)
            data.interactionStates.hover = true;
        // find and store all nodes that are within the group
        __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")[__classPrivateFieldGet(this, _HoverManager_nodes, "f").length - 1] = [];
        __classPrivateFieldGet(this, _HoverManager_groupInteractionEffectToken, "f")[__classPrivateFieldGet(this, _HoverManager_nodes, "f").length - 1] = [];
        if (data && data.groupId)
            __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")[__classPrivateFieldGet(this, _HoverManager_nodes, "f").length - 1] =
                this.gatheredGroupedNodes[data.groupId] || [];
        const { token, groupTokens } = InteractionManagerUtils_1.InteractionManagerUtils.applyInteractionEffects(intersection.node, __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")[__classPrivateFieldGet(this, _HoverManager_nodes, "f").length - 1], this.interactionEffect, this.interactionEffectUtils);
        __classPrivateFieldGet(this, _HoverManager_interactionEffectTokens, "f").push(token);
        __classPrivateFieldGet(this, _HoverManager_groupInteractionEffectToken, "f")[__classPrivateFieldGet(this, _HoverManager_nodes, "f").length - 1] = groupTokens;
        InteractionManagerUtils_1.InteractionManagerUtils.updateViewport(this.viewport, intersection.node, __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")
            ? __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")[__classPrivateFieldGet(this, _HoverManager_nodes, "f").length - 1]
            : undefined);
        __classPrivateFieldGet(this, _HoverManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.HOVER_ON, {
            viewportId: this.viewport.id,
            nodes: __classPrivateFieldGet(this, _HoverManager_nodes, "f"),
            intersectionPoint: intersection.type === "RayTracingIntersection"
                ? intersection.point
                : undefined,
            ray,
            event,
            manager: this,
            groupedNodes: __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")[__classPrivateFieldGet(this, _HoverManager_nodes, "f").length - 1],
        });
    }
    deactivateAllNodes() {
        while (__classPrivateFieldGet(this, _HoverManager_nodes, "f").length > 0)
            this.deactivateNode(__classPrivateFieldGet(this, _HoverManager_nodes, "f")[0]);
    }
    /**
     * Utility function to make the node inactive.
     * Set the according values, remove the effect and emit the event.
     *
     * @param event
     */
    deactivateNode(node, event) {
        if (!InteractionManagerUtils_1.InteractionManagerUtils.validateViewport(this.viewport, __classPrivateFieldGet(this, _HoverManager_logger, "f")))
            return;
        // find the interaction data
        const data = InteractionManagerUtils_1.InteractionManagerUtils.getInteractionData(node, true, this.id, "hover");
        if (data)
            data.interactionStates.hover = false;
        const index = __classPrivateFieldGet(this, _HoverManager_nodes, "f").indexOf(node);
        if (index === -1)
            return;
        InteractionManagerUtils_1.InteractionManagerUtils.removeInteractionEffects(node, __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")[index], __classPrivateFieldGet(this, _HoverManager_interactionEffectTokens, "f")[index], __classPrivateFieldGet(this, _HoverManager_groupInteractionEffectToken, "f")[index] || [], this.interactionEffectUtils);
        InteractionManagerUtils_1.InteractionManagerUtils.updateViewport(this.viewport, node, __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")[index]);
        // Store the grouped nodes before removing from arrays for the event
        const groupedNodes = __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f")[index];
        __classPrivateFieldGet(this, _HoverManager_nodes, "f").splice(index, 1);
        __classPrivateFieldGet(this, _HoverManager_interactionEffectTokens, "f").splice(index, 1);
        __classPrivateFieldGet(this, _HoverManager_groupedNodes, "f").splice(index, 1);
        __classPrivateFieldGet(this, _HoverManager_groupInteractionEffectToken, "f").splice(index, 1);
        __classPrivateFieldGet(this, _HoverManager_eventEngine, "f").emitEvent(viewer_shared_services_1.EVENTTYPE.INTERACTION.HOVER_OFF, {
            viewportId: this.viewport.id,
            nodes: __classPrivateFieldGet(this, _HoverManager_nodes, "f"),
            event,
            manager: this,
            groupedNodes: groupedNodes,
        });
    }
}
exports.HoverManager = HoverManager;
_HoverManager_eventEngine = new WeakMap(), _HoverManager_logger = new WeakMap(), _HoverManager_tree = new WeakMap(), _HoverManager_currentlyDragging = new WeakMap(), _HoverManager_dragEventTokenEnd = new WeakMap(), _HoverManager_dragEventTokenStart = new WeakMap(), _HoverManager_filter = new WeakMap(), _HoverManager_groupInteractionEffectToken = new WeakMap(), _HoverManager_groupedNodes = new WeakMap(), _HoverManager_interactionEffectTokens = new WeakMap(), _HoverManager_intersections = new WeakMap(), _HoverManager_nodes = new WeakMap();
//# sourceMappingURL=HoverManager.js.map